import React from 'react';
import { useState } from 'react';
import SEOHead from '../components/SEOHead';
import { Header } from '../components/landing/Header';
import { Hero } from '../components/landing/Hero';
import { About, Features, USADeliveryBanner, WhyChooseUs, Services } from '../components/landing/InfoSections';
import { HowItWorks } from '../components/landing/HowItWorks';
import { Shipments } from '../components/landing/Shipments';
import { CabinetBenefits } from '../components/landing/CabinetBenefits';
import { BlogArticles, Blog } from '../components/landing/BlogSection';
import { FAQ } from '../components/landing/FAQ';
import { TariffsSection } from '../components/landing/TariffsSection';
import { Partners, ShippingPartners } from '../components/landing/Partners';
import { Testimonials } from '../components/landing/Testimonials';
import { Footer, FloatingButtons } from '../components/landing/Footer';
import { SideLeadPopup } from '../components/landing/SideLeadPopup';
import { LeadBoosters } from '../components/landing/LeadBoosters';
import { SocialProofPopups } from '../components/landing/SocialProofPopups';
import { CompanyNews } from '../components/landing/CompanyNews';
import { QuizPopup } from '../components/landing/QuizPopup';
import { ChinaPaymentBlock } from '../components/landing/ChinaPaymentBlock';
import { WhatWeShip } from '../components/landing/WhatWeShip';
import { NewsTicker } from '../components/landing/NewsTicker';

export const LandingPage = () => {
  const [leadDone, setLeadDone] = useState(false);
  return (
    <div className="min-h-screen bg-[#060a13] electro-grid">
      <SEOHead pageSlug="home" />
      <Header />
      <main>
        <NewsTicker />
        <Hero />
        <WhatWeShip />
        <ChinaPaymentBlock onCta={() => window.dispatchEvent(new Event('open-lead-popup'))} />
        <About />
        <HowItWorks />
        <Features />
        <USADeliveryBanner />
        <WhyChooseUs />
        <Shipments />
        <CompanyNews />
        <CabinetBenefits />
        <BlogArticles />
        <FAQ />
        <Blog />
        <Services />
        <TariffsSection />
        <Partners />
        <ShippingPartners />
        <Testimonials />
      </main>
      <Footer />
      <FloatingButtons />
      <SideLeadPopup onDone={() => setLeadDone(true)} />
      <LeadBoosters />
      <SocialProofPopups active={leadDone} />
      <QuizPopup />
    </div>
  );
};
